export default __webpack_public_path__ + "static/media/castle_card_bg0.b6177b0b.png";